import { render } from "./BiJiaoView.vue?vue&type=template&id=199fc0d6&scoped=true&ts=true"
import script from "./BiJiaoView.vue?vue&type=script&lang=ts"
export * from "./BiJiaoView.vue?vue&type=script&lang=ts"

import "./BiJiaoView.vue?vue&type=style&index=0&id=199fc0d6&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199fc0d6"]])

export default __exports__